import { ValidationResult } from "lib/hooks/use-input";
import { emailRegex } from "lib/utils";

export const emailValidator = (v: string): ValidationResult => {
  if (!emailRegex.test(v)) {
    return {
      valid: false,
      message: "Please enter a valid email",
    };
  }
  return { valid: true };
};
